import React from "react";
import HQAddress from "./HQAddress";
import MailingAddress from "./MailingAddress";
import classes from "./CompanyAddress.module.css";

const CompanyAddress = () => {
    return (
        <div className={classes.organizationAddress}>
            <HQAddress />
            <MailingAddress />
        </div>
    );
};

export default CompanyAddress;
